export const dateFormats = {
    shortYearMonthPeriod: "YYYY-MM",
    shortYearMonthPoint: "YYYY.MM",
    fullMonthYear: "MMMM YYYY",
    shortMonthYear: "MMM YYYY",
    fullYear: "YYYY",
    fullMonth: "MMMM",
    shortMonth: "MMM",
    day: "DD",
    fullDate: "YYYY.MM.DD",
    beDateFormat: "YYYY|MM|DD",
    shortMonthDayYear: "MMMM DD, YYYY",
};
